import * as Yup from 'yup'
import { Form } from 'react-bootstrap'

export const Schema = Yup.object().shape({
    terms: Yup.bool().required().oneOf([true], 'Die Datenschutzbestimmungen müssen akzeptiert werden'),
});

export const PrivacyConsentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { dataSecurityUrl } = props;
    return (
        <>
            <Form.Group controlId="privacyConsent">
                <Form.Text muted style= {{textDecoration: "underline"}}>Hinweise:</Form.Text>
                <Form.Text muted><br></br>Bei kompletter Bewerbungsmappe, diese bitte unter Lebenslauf hochladen.<br></br>Weitere Unterlagen - Mehrfachauswahl möglich: Maximal 11 Dateien (Lebenslauf + 10 weitere Dateien) mit insgesamt 15.00 MB<br></br>Mögliche Dateiformate: jpg, pdf, png, tif<br></br>Um alle hochgeladenen Dateien anzeigen zu lassen „Ausgewählte Dateien“ ausklappen<br></br> </Form.Text>
                <Form.Check style={{marginTop:"20px"}}
                    required
                    name="terms"
                    type="checkbox"
                    onChange={handleChange}
                    isInvalid={touched.terms && !!errors.terms}
                    feedback={errors.terms}
                    feedbackType="invalid"
                    label={<span>* Ich habe die <a href={dataSecurityUrl} target="_blank" rel="noreferrer" >Datenschutzbestimmungen</a> zur Kenntnis genommen.</span>}>
                </Form.Check>
            </Form.Group>
        </>
    );
};